/**
 * 바우처/티켓 실시간 현황 위젯
 */

import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { VoucherTicketStatus as VoucherTicketStatusType } from '../../types/dashboard';
import './VoucherTicketStatus.css';

interface VoucherTicketStatusProps {
  data: VoucherTicketStatusType;
}

const VoucherTicketStatus: React.FC<VoucherTicketStatusProps> = ({ data }) => {
  return (
    <Card className="voucher-ticket-status-card">
      <Card.Header className="voucher-ticket-status-header">
        <h5 className="mb-0" style={{ color: '#fff' }}>
          📊 바우처/티켓 실시간 현황
        </h5>
        <small style={{ color: '#888' }}>오늘 기준 처리 현황</small>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <div className="status-section">
              <h6 className="status-section-title">바우처 현황</h6>
              <div className="status-grid">
                <div className="status-item">
                  <div className="status-label">발급</div>
                  <div className="status-value issued">{data.vouchers_issued_today}</div>
                </div>
                <div className="status-item">
                  <div className="status-label">교환</div>
                  <div className="status-value exchanged">{data.vouchers_exchanged_today}</div>
                </div>
                <div className="status-item">
                  <div className="status-label">만료</div>
                  <div className="status-value expired">{data.vouchers_expired_today}</div>
                </div>
                <div className="status-item">
                  <div className="status-label">취소</div>
                  <div className="status-value cancelled">{data.vouchers_cancelled_today}</div>
                </div>
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className="status-section">
              <h6 className="status-section-title">티켓 현황</h6>
              <div className="status-grid">
                <div className="status-item">
                  <div className="status-label">발급</div>
                  <div className="status-value issued">{data.tickets_issued_today}</div>
                </div>
                <div className="status-item">
                  <div className="status-label">사용</div>
                  <div className="status-value used">{data.tickets_used_today}</div>
                </div>
                <div className="status-item">
                  <div className="status-label">만료</div>
                  <div className="status-value expired">{data.tickets_expired_today}</div>
                </div>
                <div className="status-item">
                  <div className="status-label">취소</div>
                  <div className="status-value cancelled">{data.tickets_cancelled_today}</div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div className="status-summary">
          <Row>
            <Col md={6}>
              <div className="summary-item">
                <span className="summary-label">바우처 총 처리</span>
                <span className="summary-value">
                  {data.vouchers_issued_today + data.vouchers_exchanged_today + 
                   data.vouchers_expired_today + data.vouchers_cancelled_today}
                </span>
              </div>
            </Col>
            <Col md={6}>
              <div className="summary-item">
                <span className="summary-label">티켓 총 처리</span>
                <span className="summary-value">
                  {data.tickets_issued_today + data.tickets_used_today + 
                   data.tickets_expired_today + data.tickets_cancelled_today}
                </span>
              </div>
            </Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  );
};

export default VoucherTicketStatus;

